import styled from "styled-components";
const Title = styled.h2<{ $smallPadding?: boolean }>`
  margin: ${(props) =>
    props.$smallPadding ? "4rem 2rem 0 2rem" : "4rem 2rem 0 4rem"};
  text-align: left;
  font-size: 20px;
  font-weight: 500;
`;

export const TitleComponent: React.FC<{
  text: string;
  smallPadding?: boolean;
}> = ({ text, smallPadding }) => {
  return <Title $smallPadding={smallPadding}>{text}</Title>;
};
export default TitleComponent;
